import React, { useCallback, useContext, useState,useEffect } from "react";
import { ModalNextContext} from '@jutro/components';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';

import { withRouter } from 'react-router-dom';
import { LoaderExt } from 'gw-components-platform-react';
import { messages as commonMessages } from '@xengage/gw-platform-translations';
import { IntlContext } from "@jutro/locale";
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import moment from 'moment';
import  usecpmiAnalytics from '../../../../account-management/src/hooks/usecpmiAnalytics';
import PayrollService from "../../../capabilities/cpmi-capability-payroll/services/PayrollService";
import styles from './SubmitPayroll.module.scss';
import metadata from './SubmitPayroll.metadata.json5';
import messages from './SubmitPayroll.messages';
import useGoogleAnalytics from "../../../../account-management/src/hooks/useGoogleAnalytics";



function SubmitPayroll(props) {
    const {
        history: {
            location: { state }
        },history,
    }=props;
    
    const splitTerm = props?.location?.state?.termperiod?.split('-');
    const[mail,setmail]=useState();
    const[trackPageView,trackEvent] = usecpmiAnalytics();
    const[trackGAPageView]=useGoogleAnalytics();
    const[name,setName]=useState();
    const[phoneNumber,setPhoneNumber]=useState('');
    const[description,setDescription]=useState('');
    const [isLoading, setLoadingState] = useState(true);
    
    
    const { authHeader } = useAuthentication();
    const ModalNext=useContext(ModalNextContext);
    const [payroll, setpayroll] = useState(
        {}
    );
    const rowData=props?.location?.state?.item;
    const params={ };
    params.policyNumber=rowData?.policyNumber;
    params.reportPeriodEnd=rowData?.reportPeriodEnd;
    params.reportPeriodStart=rowData?.reportPeriodStart;
    params.reportCompletionDate=rowData?.reportCompletionDate;
    params.policyPeriodStart= new Date(splitTerm[0]).toISOString();
    params.policyPeriodEnd=  new Date(splitTerm[1]).toISOString();

    const {
        onValidate,
        isComponentValid,
      
    } = useValidation('SubmitPayroll');

    

    useEffect(() => {
        trackPageView("submit payroll","/payroll-reporting/payrollchange");
    },[])

    useEffect(() => {
        trackGAPageView("/payroll-reporting/payrollchange","submit payroll");
    },[])

    useEffect(()=>{
        if(state.appValue==="PE"){
            PayrollService.PEgetPayrollUserContactDetails(authHeader).then((res) => {   
                setpayroll(res);
                setLoadingState(false);
              
            });
        }
        else{
            PayrollService.getPayrollUserContactDetails(authHeader).then((res) => {
                
                setpayroll(res);
                setLoadingState(false);
            });
        }

    },[])

    useEffect(()=>{
        setmail(payroll.contactEmail);
        setName(payroll.contactName);
  
    },[payroll])

    const intl = useContext(IntlContext);
    const getPolicyNumber=useCallback(()=>{
        
       
        return rowData?.policyNumber;
    },[rowData])


    const getTermNumber=useCallback(()=>{

        return props?.location?.state?.termperiod;
    },[props?.location?.state?.termperiod])

    const getReportingPeriod=useCallback(()=>{
        const startDate=moment(rowData.reportPeriodStart).format('MM/DD/YYYY');
        const endDate=moment(rowData.reportPeriodEnd).format('MM/DD/YYYY');
        return `${startDate} - ${endDate}`;

    },[rowData.reportPeriodEnd, rowData.reportPeriodStart])
    
    params.contactPhone=phoneNumber;
    params.contactName=name;
    params.contactEmail=mail;
    params.requestDescription=description;
    const handlemail=useCallback((value) => setmail(value),[]);
    const handleName=useCallback((value) => setName(value),[]);
    const handlePhone=useCallback((value) => setPhoneNumber(value),[]);
    const handleDescription=useCallback((value) => setDescription(value),[]);
   
    
    

    


    
   


    
    


    const submitChange=useCallback(()=>{
        

        if(state.appValue==="PE"){
            PayrollService.PEcreatePayrollChangeRequest(params,authHeader).then((res)=>{
                // return history.push({
                //     pathname: `/policies/${state.policyNumber}/list`,
                // });
                if(res === true){
                    history.push({pathname:props.location.pathname})
                }
            })
               
        }
        else{
            PayrollService.createPayrollChangeRequest(params,authHeader).then((res)=>{
                
                const { redirectPath } = state;
                return history.push({
                    pathname: `/payroll-reporting/list/selectedTerm`,
                    state: {
                           
                        redirectPath: redirectPath,
                    },
                });
            })
        }
           
        
    },[authHeader, history, params, state])


    const cancelChange = useCallback(() => {
        ModalNext.showConfirm({
            title: messages.cancelChangeTitle,
            message: messages.cancelChangeMessage,
            status: 'info',
            icon: 'mi-error-outline',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        }).then((results) => {
            if(results === 'confirm'){
                history.go(-1);
            }
        }, _.noop);
    },[]);

    if (isLoading) {
        // eslint-disable-next-line react/react-in-jsx-scope
        return <LoaderExt loaded={!isLoading} />;
    }

    const getPhoneValidation= ()=>{
        
        const regex= /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/
        // const regex=/^\(?([2-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/
       
        if(!regex.test(phoneNumber))
        {
            return ["Value entered must be a valid phone number"]
        }
        
        return  []      
    }


    const getMailValidation=()=>{
        const regex= /\S+@\S+\.\S+/;

    
        if(!regex.test(mail))
        {
            return ["Value must be a valid email address"]
        }
    
        return []
     
    }

    const overrides = {
        policyNumber:{
            value:getPolicyNumber()
        },
        reportPeriod:{
            value:getReportingPeriod()
        },
        email:{
            
            value:mail,
            onValueChange:handlemail,
            validationMessages:getMailValidation()
          
        },
        name:{
            
            value:name,
            onValueChange:handleName
           
        },
        term:{
            value:getTermNumber()

        },
        phone:{
            
            value:phoneNumber,
            onValueChange:handlePhone,
            validationMessages:getPhoneValidation()
          
        },
        description:{
            
            value:description,
            onValueChange:handleDescription
           
        },
        ok:{
            // disabled:buttonVisibility
            disabled:!isComponentValid
        }
       
        
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {
            
        },
        resolveCallbackMap:{
            cancelChange,
            getPolicyNumber,
            getReportingPeriod,
            submitChange,
            getTermNumber
        }
    };

    return  <ViewModelForm
        uiProps={metadata.pageContent}
        // model={payrollvm}
        overrideProps={overrides}
        onValidationChange={onValidate}
        componentMap={resolvers.resolveComponentMap}
        classNameMap={resolvers.resolveClassNameMap}
        callbackMap={resolvers.resolveCallbackMap}
    />
}

export default withRouter(SubmitPayroll);